import { Box, Typography, useTheme } from "@mui/material";
import { WfIconContentDraggableRegular } from "@WahooFitness/redesignr";

const RankItem = ({ text, disabled }: { text: string; disabled: boolean }) => {
  const { palette } = useTheme();
  return (
    <Box
      border={`1px solid ${palette.divider}`}
      borderRadius={2}
      p={1.5}
      display="flex"
      gap={1}
      sx={{ cursor: "grab" }}
      bgcolor={palette.background.level1}
    >
      <WfIconContentDraggableRegular fill="text.disabled" />
      <Typography color={disabled ? palette.text.disabled : "primary"}>{text}</Typography>
    </Box>
  );
};

export default RankItem;
